module.exports = __webpack_public_path__ + "img/soundfield_6.e1f3d98f.jpg";